import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  drawerText: { fontFamily: 'Ubuntu-Bold', fontSize: 18, color: '#E81E2B' },
});
